export type TextRange = readonly [start: number, end: number];

function escapeRegExp(text: string): string {
  return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

/** Case-insensitive, non-overlapping occurrences of the trimmed query, as [start, end) offsets. */
export function textOccurrences(text: string | null | undefined, query: string | null | undefined): TextRange[] {
  const needle = (query ?? '').trim();
  if (!text || !needle) return [];
  const pattern = new RegExp(escapeRegExp(needle), 'giu');
  const ranges: TextRange[] = [];
  let match = pattern.exec(text);
  while (match) {
    if (match[0].length === 0) break;
    ranges.push([match.index, match.index + match[0].length]);
    match = pattern.exec(text);
  }
  return ranges;
}
